import { all, put, SagaIterator, takeEveryCompletedRequest, takeEveryErrorRequest } from './core/sagaEffects';
import { FetchRequest } from 'acscp/actions';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses/core/responseTypes';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import { LoyaltyOrderRequest } from 'acscp/api/requests/loyaltyOrderRequest';
import { GiftsRequest } from 'acscp/api/requests/giftsRequest';

export function* orderSubmitSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(LoyaltyOrderRequest, handleHandleOrderSubmitSuccess),
        takeEveryErrorRequest(LoyaltyOrderRequest, handleHandleOrderSubmitErrors)
    ]);
}

export function* handleHandleOrderSubmitSuccess(
    response: undefined,
    request: LoyaltyOrderRequest
): SagaIterator {
    yield put(new FetchRequest(new GiftsRequest()));
}

export function* handleHandleOrderSubmitErrors(
    responseType: ResponseErrorTypes,
    error: ErrorDetails,
    request: LoyaltyOrderRequest
): SagaIterator {
    if (responseType === ResponseType.RequestError) {
        yield put(new FetchRequest(new GiftsRequest()));
    }
}
